/** Never throw. Missing / non-string values become "". */
export function safeTrim(value: unknown): string {
  if (typeof value === "string") return value.trim();
  if (typeof value === "number" && Number.isFinite(value)) return String(value);
  return "";
}
